// The initials avatar of the hub and of Perfil (SPEC-16, SPEC-17): no photo
// in this cycle, the first two letters of her first name on violet tint.

/** The first two letters of her first name, capitals (SPEC-16, Action list). */
export const initialsOf = (firstName: string) => Array.from(firstName.trim()).slice(0, 2).join("").toUpperCase();

const SIZES = {
  /** The hub's header. */
  small: "size-9 text-caption",
  /** The hub's profile card, 48 px. */
  medium: "size-12 text-title-sm",
  /** Perfil, 80 px. */
  large: "size-20 text-question",
} as const;

export function Avatar({ firstName, size }: { firstName: string; size: keyof typeof SIZES }) {
  return (
    <span
      aria-hidden="true"
      className={`flex shrink-0 items-center justify-center rounded-pill bg-violet-tint font-semibold text-violet-ink ${SIZES[size]}`}
    >
      {initialsOf(firstName)}
    </span>
  );
}
